import { render, staticRenderFns } from "./user-followup-3.vue?vue&type=template&id=ec503a66&scoped=true"
import script from "./user-followup-3.vue?vue&type=script&lang=js"
export * from "./user-followup-3.vue?vue&type=script&lang=js"
import style0 from "./user-followup-3.vue?vue&type=style&index=0&id=ec503a66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec503a66",
  null
  
)

export default component.exports